/**
 * defa.collections.Subscriptions
 * A Collection of Subscriptions with custom filters.
 * @version 1.2.0
 */
import Subscription from 'scripts/defa/subscriptions/model-subscription';

const Subscriptions = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: Subscription,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new Subscriptions collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {collection}      The filtered CustomerCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( subscription ) {
			return _.contains( ids, subscription.get( 'id' ) );
		} );
		
		return new Subscriptions( array );
	},
	
} );

export default Subscriptions;